"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortDirection = exports.RelativeDelayStartType = exports.ReferenceType = exports.CurrencyDisplayType = exports.NumberFormatStyle = exports.LogicalOperator = exports.ComparisonOperator = exports.AlignType = exports.NodeType = exports.Role = exports.LocaleMatcher = void 0;
var LocaleMatcher;
(function (LocaleMatcher) {
    LocaleMatcher["BEST_FIT"] = "best fit";
    LocaleMatcher["LOOKUP"] = "lookup";
})(LocaleMatcher = exports.LocaleMatcher || (exports.LocaleMatcher = {}));
var Role;
(function (Role) {
    Role["EDITOR"] = "editor";
    Role["READER"] = "reader";
})(Role = exports.Role || (exports.Role = {}));
var NodeType;
(function (NodeType) {
    NodeType["BLOCKQUOTE"] = "blockquote";
    NodeType["BOARD_VIEW"] = "boardView";
    NodeType["BOOLEAN_VIEW"] = "booleanView";
    NodeType["BREAK"] = "break";
    NodeType["CALENDAR_VIEW"] = "calendarView";
    NodeType["CHECKBOX_SELECTION_VIEW"] = "checkboxSelectionView";
    NodeType["CHECKBOX_VIEW"] = "checkboxView";
    NodeType["CODE"] = "code";
    NodeType["CODE_VIEW"] = "codeView";
    NodeType["COLLECTION_VIEW"] = "collectionView";
    NodeType["CURRENCY_VIEW"] = "currencyView";
    NodeType["CURRENCY_RANGE_VIEW"] = "currencyRangeView";
    NodeType["DATE_RANGE_VIEW"] = "dateRangeView";
    NodeType["DATE_TIME_RANGE_VIEW"] = "dateTimeRangeView";
    NodeType["DATE_TIME_VIEW"] = "dateTimeView";
    NodeType["DATE_VIEW"] = "dateView";
    NodeType["DEFINITION"] = "definition";
    NodeType["DELETE"] = "delete";
    NodeType["EMAIL_VIEW"] = "emailView";
    NodeType["EMPHASIS"] = "emphasis";
    NodeType["FILE_VIEW"] = "fileView";
    NodeType["FILE_REFERENCE_VIEW"] = "fileReferenceView";
    NodeType["FILE_TABLE_REFERENCE_VIEW"] = "fileTableReferenceView";
    NodeType["FOOTNOTE"] = "footnote";
    NodeType["FOOTNOTE_DEFINITION"] = "footnoteDefinition";
    NodeType["FOOTNOTE_REFERENCE"] = "footnoteReference";
    NodeType["GALLERY_VIEW"] = "galleryView";
    NodeType["GROUP_VIEW"] = "groupView";
    NodeType["HEADING"] = "heading";
    NodeType["HTML"] = "html";
    NodeType["IMAGE"] = "image";
    NodeType["IMAGE_REFERENCE"] = "imageReference";
    NodeType["IMAGE_REFERENCE_VIEW"] = "imageReferenceView";
    NodeType["INLINE_CODE"] = "inlineCode";
    NodeType["INTEGER_VIEW"] = "integerView";
    NodeType["LINK"] = "link";
    NodeType["LINK_REFERENCE"] = "linkReference";
    NodeType["LIST"] = "list";
    NodeType["LIST_ITEM"] = "listItem";
    NodeType["LIST_VIEW"] = "listView";
    NodeType["MULTIPLE_SELECTION_VIEW"] = "multipleSelectionView";
    NodeType["NUMBER_RANGE_VIEW"] = "numberRangeView";
    NodeType["NUMBER_VIEW"] = "numberView";
    NodeType["NODE"] = "node";
    NodeType["OBJECT_VIEW"] = "objectView";
    NodeType["PARAGRAPH"] = "paragraph";
    NodeType["PARENT_VIEW"] = "parentView";
    NodeType["PASSWORD_VIEW"] = "passwordView";
    NodeType["PERCENT_VIEW"] = "percentView";
    NodeType["PERCENT_RANGE_VIEW"] = "percentRangeView";
    NodeType["PICKER_VIEW"] = "pickerView";
    NodeType["RADIO_SELECTION_VIEW"] = "radioSelectionView";
    NodeType["RANGE_VIEW"] = "rangeView";
    NodeType["REFERENCE_VIEW"] = "referenceView";
    NodeType["RELATIVE_DELAY_VIEW"] = "relativeDelayView";
    NodeType["RELATIVE_DURATION_VIEW"] = "relativeDurationView";
    NodeType["RELATIVE_TIME_VIEW"] = "relativeTimeView";
    NodeType["RICH_TEXT_VIEW"] = "richTextView";
    NodeType["ROOT"] = "root";
    NodeType["SELECTION_VIEW"] = "selectionView";
    NodeType["STRING_VIEW"] = "stringView";
    NodeType["STRONG"] = "strong";
    NodeType["SWITCH_VIEW"] = "switchView";
    NodeType["TABLE"] = "table";
    NodeType["TABLE_CELL"] = "tableCell";
    NodeType["TABLE_ROW"] = "tableRow";
    NodeType["TABLE_VIEW"] = "tableView";
    NodeType["TEXT"] = "text";
    NodeType["TEXT_AREA_VIEW"] = "textAreaView";
    NodeType["TEXT_VIEW"] = "textView";
    NodeType["THEMATIC_BREAK"] = "thematicBreak";
    NodeType["TIME_RANGE_VIEW"] = "timeRangeView";
    NodeType["TIME_VIEW"] = "timeView";
    NodeType["TOGGLE_SWITCH_VIEW"] = "toggleSwitchView";
    NodeType["URL_VIEW"] = "urlView";
    NodeType["VIEW"] = "view";
    NodeType["YAML"] = "yaml";
})(NodeType = exports.NodeType || (exports.NodeType = {}));
var AlignType;
(function (AlignType) {
    AlignType["CENTER"] = "center";
    AlignType["LEFT"] = "left";
    AlignType["RIGHT"] = "right";
})(AlignType = exports.AlignType || (exports.AlignType = {}));
var ComparisonOperator;
(function (ComparisonOperator) {
    ComparisonOperator["EQ"] = "eq";
    ComparisonOperator["GT"] = "gt";
    ComparisonOperator["GTE"] = "gte";
    ComparisonOperator["LT"] = "lt";
    ComparisonOperator["LTE"] = "lte";
})(ComparisonOperator = exports.ComparisonOperator || (exports.ComparisonOperator = {}));
var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["AND"] = "and";
    LogicalOperator["OR"] = "or";
})(LogicalOperator = exports.LogicalOperator || (exports.LogicalOperator = {}));
var NumberFormatStyle;
(function (NumberFormatStyle) {
    NumberFormatStyle["DECIMAL"] = "decimal";
    NumberFormatStyle["CURRENCY"] = "currency";
    NumberFormatStyle["PERCENT"] = "percent";
    NumberFormatStyle["UNIT"] = "unit";
})(NumberFormatStyle = exports.NumberFormatStyle || (exports.NumberFormatStyle = {}));
var CurrencyDisplayType;
(function (CurrencyDisplayType) {
    CurrencyDisplayType["CODE"] = "code";
    CurrencyDisplayType["NAME"] = "name";
    CurrencyDisplayType["SYMBOL"] = "symbol";
})(CurrencyDisplayType = exports.CurrencyDisplayType || (exports.CurrencyDisplayType = {}));
var ReferenceType;
(function (ReferenceType) {
    ReferenceType["COLLAPSED"] = "collapsed";
    ReferenceType["FULL"] = "full";
    ReferenceType["SHORTCUT"] = "shortcut";
})(ReferenceType = exports.ReferenceType || (exports.ReferenceType = {}));
var RelativeDelayStartType;
(function (RelativeDelayStartType) {
    RelativeDelayStartType["PARENT_READY"] = "PARENT_READY";
    RelativeDelayStartType["SELF_READY"] = "SELF_READY";
})(RelativeDelayStartType = exports.RelativeDelayStartType || (exports.RelativeDelayStartType = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
//# sourceMappingURL=type.js.map